// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__20v62","header":"MessagesList_header__1Fk4_","chat":"MessagesList_chat__3Zr5Q"};